<div class="auth-page">
  <div class="auth-shell auth-shell--login kota-enter-seq">
    <div class="auth-shell__form">
      <a routerLink="/" class="auth-logo">
        <img src="assets/img/kota_logo.png" alt="KOTA" class="auth-logo__img" />
      </a>

      <div class="auth-heading">
        <h1 class="auth-title">Bienvenido de Vuelta</h1>
        <p class="auth-subtitle">Ingresa a tu cuenta para continuar comprando</p>
      </div>

      <form class="auth-form" (ngSubmit)="onSubmit()">
        <div class="auth-field">
          <label class="auth-label" for="login-email">Correo electrónico</label>
          <div class="auth-input-wrap">
            <input
              id="login-email"
              name="email"
              type="email"
              class="auth-input"
              placeholder="tu@email.com"
              [(ngModel)]="email"
              autocomplete="email"
              required
            />
          </div>
        </div>

        <div class="auth-field">
          <label class="auth-label" for="login-password">Contraseña</label>
          <div class="auth-input-wrap">
            <input
              id="login-password"
              name="password"
              [type]="showPassword() ? 'text' : 'password'"
              class="auth-input"
              placeholder="••••••••"
              [(ngModel)]="password"
              autocomplete="current-password"
              required
            />
            <button type="button" class="auth-toggle-pass" (click)="togglePassword()" [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              @if (showPassword()) {
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              } @else {
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                  <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                  <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                  <line x1="2" x2="22" y1="2" y2="22" />
                </svg>
              }
            </button>
          </div>
        </div>

        <div class="auth-options">
          <label class="auth-remember">
            <input type="checkbox" class="auth-checkbox" name="remember" [(ngModel)]="rememberMe" />
            <span class="auth-checkbox-ui" [class.is-checked]="rememberMe">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </span>
            Recordarme
          </label>
          <a href="#" class="auth-link" (click)="noopSocial($event)">¿Olvidaste tu contraseña?</a>
        </div>

        <button type="submit" class="auth-btn auth-btn--primary">Iniciar Sesión</button>
      </form>

      <div class="auth-divider">
        <span class="auth-divider__line"></span>
        <span class="auth-divider__text">o continúa con</span>
        <span class="auth-divider__line"></span>
      </div>

      <div class="auth-social">
        <button type="button" class="auth-btn auth-btn--social" (click)="noopSocial($event)">
          <span style="font-size: 18px; font-weight: 700">G</span>
          Google
        </button>
        <button type="button" class="auth-btn auth-btn--social" (click)="noopSocial($event)">
          <svg class="fb-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
          </svg>
          Facebook
        </button>
      </div>

      <p class="auth-switch">
        <span class="auth-switch__muted">¿No tienes cuenta?</span>
        <a routerLink="/registro" class="auth-switch__link">Regístrate</a>
      </p>
    </div>

    <div
      class="auth-shell__image"
      role="img"
      aria-label="Interior con muebles"
      style="background-image: url('https://images.unsplash.com/photo-1768076956012-0d7f192429a6?auto=format&fit=crop&w=1200&q=80')"
    ></div>
  </div>
</div>
